import {NySelectInput} from 'nyse-web-tools-common/lib/react';
import React from 'react';

import useResource from '../../hooks/useResource.hook';
import displayBooksResource from '../../resources/displayBook.resource';

type DisplayBooksSelectProps = {
    disabled?: boolean;
    name: string;
    isMulti?: boolean;
    required?: boolean;
};

export const DisplayBooksSelect: React.FC<DisplayBooksSelectProps> = React.memo(
    (props) => {
        const resource = useResource<{label: string; value: string}[]>(
            displayBooksResource,
            true
        );

        return (
            <NySelectInput
                disabled={
                    props.disabled ||
                    (!resource.pending && resource.data.length === 0)
                }
                isLoading={resource.pending}
                isMulti={props.isMulti}
                name={props.name}
                options={resource.data}
                required={props.required}
            />
        );
    }
);
